import React from 'react';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { NewBarGraph } from 'src/components/molecules/graphs/NewBarGraph';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { useMetricsBySearchChannel } from '../../hooks/useMetricsBySearchChannel';

export const MetricsBySearchChannelBarGraph: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { data, isError, isLoading, dataKeys } = useMetricsBySearchChannel();

  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: dataKeys.data,
    placement: 'right',
  };

  return (
    <DataBox
      {...props}
      legendProps={legendProps}
      hasData={data.length > 0}
      isError={isError}
      isLoading={isLoading}>
      <NewBarGraph
        data={data}
        xAxisKey={dataKeys.xAxis}
        stacked={false}
        yAxisFormatter={ValueTickFormatter}
      />
    </DataBox>
  );
};
